import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { NotificationDeliveryMethod } from './notification-delivery-method.enum';
import { Recipient } from './recipients/recipient';
import { BaseEntity } from '@40seas/models';

export const NotificationSchema = z
    .object({
        eventType: z.string().min(1),
        payload: z.any(),
        commit: z.any().optional(),
        methods: z.array(EnumSchema(NotificationDeliveryMethod)),
        recipients: z.array(EnumSchema(Recipient)),
    })
    .strict();

export class Notification extends FromSchema(NotificationSchema) {
    eventType: string;
    payload: BaseEntity;
    commit?: Partial<BaseEntity>;
    recipients: Recipient[];
}
